import Box from '@/Atoms/Box/Box';
import CCButton from '@/Atoms/CCButton/CCButton';
import CCText from '@/Atoms/CCText';
import CCTextInput from '@/Atoms/CCTextInput';
import SlideModal from '@/Atoms/SlideModal';
import useUpdateProfileApi from '@/Hooks/ProfileApi/profileUpdateApi';
import {ScreenName} from '@/navigators/StackConstants';
import CCColors from '@/Utils/CCColors';
import {FontSizes, hs, vs, WINDOW_WIDTH} from '@/Utils/Dimensions';
import {isValidPincode} from '@/Utils/PostalCode';
import {CommonActions, useNavigation} from '@react-navigation/native';
import React, {useState} from 'react';
import {StyleSheet, View} from 'react-native';

const PincodeModal = ({
  pincode,
  setPincode,
  setShowPincodeModal,
  setModalDismissed,
  mobileNumber,
}) => {
  const [error, setError] = useState('');
  const {mutate: updateProfile, isLoading: profileLoader} = useUpdateProfileApi(
    data => {
      console.log('Update successful:', data);
      setShowPincodeModal(false);
    },
    error => {
      console.error('Update failed:', error);
      setError(error?.error);
      setPincode('');
    },
  );

  const isPincodeInvalid =
    (pincode || '').trim() !== '' &&
    !isValidPincode(pincode, {mobile_number: mobileNumber});
  const displayError =
    error || (isPincodeInvalid ? 'Please enter a valid PIN/ZIP code' : '');

  const handlePress = () => {
    if (isPincodeInvalid) {
      setError('Please enter a valid PIN/ZIP code');
      return;
    }
    setModalDismissed(true);
    updateProfile({
      email: '',
      fide_id: '',
      first_name: '',
      last_name: '',
      mobile_number: '',
      username: '',
      lic_name: '',
      cdc_name: '',
      player_type: '',
      alternate_mobile_number: '',
      pincode: pincode,
    });
    setPincode(pincode);
  };
  return (
    <View style={styles.wrapper}>
      <Box style={styles.subWrapper} flexDirection="column">
        <CCText
          fontSize={18}
          fontWeight="bold"
          textAlign="center"
          style={styles.margin}>
          Set Your PIN Code / ZIP Code
        </CCText>
        <CCText
          style={{
            maxWidth: 420,
          }}
          fontSize={14}
          textAlign="center">
          Please provide your PIN/ZIP code so that your invoice and experience
          are personalised for your location.
        </CCText>
        <CCTextInput
          label="PIN/ZIP code"
          value={pincode}
          onChangeText={text => {
            setPincode(text);
            setError('');
          }}
          style={styles.it}
        />
        <CCText
          color={CCColors.RedBg}
          style={styles.er}
          fontSize={FontSizes[12]}>
          {displayError}
        </CCText>
        <Box style={styles.btn}>
          <CCButton
            contentContainerStyle={styles.update}
            disabled={pincode.trim() === '' || isPincodeInvalid}
            onPress={handlePress}>
            <CCText fontSize={FontSizes[14]} fontWeight={500}>
              Update
            </CCText>
          </CCButton>
        </Box>
      </Box>
      {/* </View> */}
    </View>
  );
};

export default PincodeModal;

const styles = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    top: '0%', // Adjust this value to control where the overlay appears
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
  },
  subWrapper: {backgroundColor: CCColors.White, padding: 20, borderRadius: 8},
  margin: {
    marginBottom: vs(12),
  },
  it: {
    width: '100%',
    marginHorizontal: vs(8),
    marginVertical: vs(12),
    minWidth: vs(140),
    padding: vs(12),
  },
  btn: {alignSelf: 'center', marginTop: vs(8)},
  update: {
    paddingHorizontal: 34,
    paddingVertical: 6,
  },
  er: {
    marginLeft: hs(10),
  },
});
